'use client'
import React, {useState } from 'react'
import NavLinks from './NavLinks'
import { RolzoLogo } from '../icons'
import { Link } from 'navigation'
import './desktopNavbar.scss'
import { useMotionValueEvent, useScroll } from 'framer-motion'
import GoldLinkButton from '../GoldLinkButton'

const DesktopNavbar = () => {
  const { scrollY } = useScroll()

  const [isFixed, setIsFixed] = useState(false)

  useMotionValueEvent(scrollY, 'change', (position) => {
    if (position > 100) setIsFixed(true)
    else setIsFixed(false)
  })
  
  return (
    <>
      {isFixed && <div className='placeholder h-[102.5px]'></div>}
      <nav className={`desktop-nav ${isFixed ? 'fixed' : ''}`}>
        <div className='container desktop-nav-conatiner'>
          <div className='links-container'>
            <Link href='/' className='logo' >
              <RolzoLogo />
            </Link>
            <NavLinks />
          </div>
          <div className='nav-buttons leading-[1.5]'>
            <GoldLinkButton
              href='https://business.rolzo.com/auth/login'
              className='log-in-btn'
              isShowRightArrow={false}
              isNewTab
              text='Log in'
            />
            <GoldLinkButton
              href='/contact'
              hasGoldBackground
              text='Contact us'
            />
          </div>
        </div>
      </nav>
    </>
  )
}

export default DesktopNavbar
